import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import * as actions from '../actionTypes/ShipAndPayActionTypes';

export default function shippingAddressFormReducer(state = {}, action) {
    // NOSONAR
    let grAddress = null;
    let addressList = null;
    switch (action.type) {
        case actions.SUBMIT_SHIPPING_ADDRESS_FORM:
            return {
                ...state,
                shippingAddressDetails: action.shippingAddress,
                requestServiceLevels: action.shippingAddress.getServiceLevels,
            };
        case actions.SERVICE_LEVELS_REQUESTED:
            return { ...state, requestServiceLevels: action.getServiceLevels };
        case actions.CHANGE_ADDRESS_TYPE:
            return { ...state, shippingAddressType: action.addressType };
        case actions.SHOW_HIDE_MILITARY_ADDRESS_FIELDS:
            return { ...state, displayAFOAddressFields: action.value };
        case actions.SUBMIT_SHIPPING_ADDRESS_FORM_FAILURE:
            return {
                ...state,
                submissionFailureResponse: action.submitAddressResponse,
                isAddressAddedOrUpdated: undefined,
            };
        case actions.SUBMIT_SHIPPING_ADDRESS_FORM_SUCCESS:
            return { ...state, submissionResponse: action.submitAddressResponse };
        case actions.CLEAR_ADDRESS_LIST:
            return { ...state, addressList: [], isAddressAddedOrUpdated: false };
        case actions.ADD_ADDRESS_TO_ADDRESS_LIST:
            return {
                ...state,
                ...(state.addressList === undefined || state.addressList.length === 0
                    ? { addressList: [action.address], isAddressAddedOrUpdated: false }
                    : findIndex(state.addressList, action.address) === -1 &&
                      state.addressList.unshift(action.address)),
            };
        case actions.ADD_ADDRESSES_TO_ADDRESS_LIST:
            grAddress = find(
                state.addressList,
                (address) => !isEmpty(get(address, 'address.relationships.giftRegistry'))
            );
            addressList = action.addressList;
            grAddress && !isEmpty(grAddress) && addressList.unshift(grAddress);
            return {
                ...state,
                addressList,
                isAddressAddedOrUpdated: false,
                showShippingAddressFields: action.addressList.length === 0,
                accountCallSucceeded: true,
            };

        case actions.SET_ADDRESS_STANDARDIZATION:
            return { ...state, isXStandardizationRequired: action.isXStandardizationRequired };
        case actions.SET_SELECTED_ADDRESS:
            return { ...state, selectedAddress: action.selectedAddress };
        case actions.SET_DEFAULT_ADDRESS:
            return {
                ...state,
                defaultAddress: action.payload.selectedAddress,
                selectedAddress: !action.payload.updateSelectedAddress
                    ? action.payload.selectedAddress
                    : state.selectedAddress,
            };
        case actions.SET_ORDER_SHIPPING_METHODS:
            return { ...state, shippingMethods: action.shippingMethods };
        case actions.IS_SHOWING_SHIPPING_ADDRESS:
            return { ...state, showShippingAddressFields: action.showShippingAddressFields };
        case actions.HANDLE_INTERNATIONAL_SHIPPING_ERROR:
            return {
                ...state,
                handleInternationalShippError: action.handleInternationalShippError,
                requestServiceLevels: true,
            };
        case actions.GET_ADDRESS_LIST_RESPONDED:
            return {
                ...state,
                getAddressListResponded: true,
                getAddressListResponse: action.getAddressListResponse,
            };
        case actions.NO_ACTION:
        default:
            return state;
    }
}
